import React, { Component } from 'react';

const WithTooltip = (WrappedComponent) => {
	class TooltipWrap extends Component {
		constructor(props) {
			super(props);
			this.state = {
				show: false
			};
			this.wrapper = React.createRef();
			this.tooltip = React.createRef();
		}
		onMouseEnter = (e) => {
			this.setState({show: true});
		}
		onMouseLeave = (e) => {
			this.setState({show: false});
		}
		onMouseMove = (e) => {
			const wrapperBound = this.wrapper.current.getBoundingClientRect();
			this.tooltip.current.style.top = e.clientY - wrapperBound.top + 'px';
			this.tooltip.current.style.left = e.clientX - wrapperBound.left + 'px';
		}
		render() {
			let wrapperStyle = {
				position: 'relative',
				perspective: 'none',
			}
			let ttStyle = {
				pointerEvents: 'none',
				position: 'absolute',
				zIndex: 1000,
				visibility: (this.state.show)? 'visible' : 'hidden',
				width: '6em',
				transform: 'translate3d(0, -100%, 500px)',
			}
			return (
				<div ref={this.wrapper} 
					className="WithTooltip" style={wrapperStyle}
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}
					onMouseMove={this.onMouseMove}>
					<WrappedComponent {...this.props} />
					<span ref={this.tooltip} className="Tooltip" style={ttStyle}>
						<span className="Tooltip-inner">
							{this.props.tooltip}
						</span>
					</span>
				</div>
			)
		}
	}
	return TooltipWrap;
}
export default WithTooltip;


// WEBPACK FOOTER //
// ./src/components/common/WithTooltip.jsx